export default {
  lang: {
    selectAll: 'Selecionando todas as páginas',
    selected: 'Selecionadas',
    term: 'Artigo',
    deselect: 'Cancelar seleção',
  },
};
